import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5001/api/v1";

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const scheduleH1Service = {
  recordEntry: async (data: {
    productId: string;
    batchNumber?: string;
    patientName: string;
    patientAge?: number;
    patientAddress?: string;
    doctorName: string;
    doctorRegistration?: string;
    prescriptionNumber: string;
    prescriptionDate: string;
    quantityDispensed: number;
    quantityUnit?: string;
    openingBalance: number;
    invoiceId?: string;
    remarks?: string;
  }) => {
    const response = await api.post("/schedule-h1", data);
    return response.data;
  },

  getDrugRegister: async (params?: {
    productId?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }) => {
    const response = await api.get("/schedule-h1/register", { params });
    return response.data;
  },

  generateReport: async (startDate: string, endDate: string) => {
    const response = await api.get("/schedule-h1/report", {
      params: { startDate, endDate },
    });
    return response.data;
  },

  getProductBalance: async (productId: string) => {
    const response = await api.get(`/schedule-h1/balance/${productId}`);
    return response.data;
  },

  getEntry: async (id: string) => {
    const response = await api.get(`/schedule-h1/${id}`);
    return response.data;
  },
};
